// extracted by mini-css-extract-plugin
module.exports = {"totalWrp":"Home_totalWrp__O136r","viewSelect":"Home_viewSelect__1mtu9","totalItem":"Home_totalItem__1o33-"};